<template>
  <div class="per-container">
    <div class="flexbox-container">
      <div class="wrap">
        <LoginHeader></LoginHeader>
        <div class="content">
          <ContentLeft></ContentLeft>
          <ContentRight></ContentRight>
        </div>
      </div>
    </div>
    <div class="bottom">产品监制 | 比亚迪汽车产业办</div>
  </div>
</template>

<script>
import LoginHeader from './components/LoginHeader'
import ContentLeft from './components/ContentLeft'
import ContentRight from './components/ContentRight'

export default {
  name: "Login",
  components: { LoginHeader, ContentLeft, ContentRight },
  data() {
    return {
    };
  },
  methods: {},
};
</script>
<style scoped>
.flexbox-container {
  width: 100%;
  color: #fff;
  background-image: url("../../assets/img/BG.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
}

.wrap {
  width: 900px;
  height: 100%;
  margin: 0 auto;
  position: relative;
}

.content {
  width: 100%;
  height: 499px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
}

.bottom {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 20px;
  width: 100%;
  text-align: center;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
}
</style>
